import { checkPermission } from "infra/helpers/permission";

function useHasPermission(permission: string | string[]) {
  return checkPermission(permission);
}

export default useHasPermission;
